var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgErrorIcn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    fill: "#262949"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9821 16.2617L15.148 8.5H12.8903L13.0689 16.2617H14.9821ZM12.75 18.2278C12.75 18.9988 13.2347 19.5 14 19.5C14.7526 19.5 15.25 18.9988 15.25 18.2278C15.25 17.4696 14.7526 16.9813 14 16.9813C13.2347 16.9813 12.75 17.4696 12.75 18.2278Z",
    fill: "#EA7E68"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIcn);
export default __webpack_public_path__ + "static/media/error-icn.02d92edf8952afb6fe0f8e026fe0bf18.svg";
export { ForwardRef as ReactComponent };